import React, { Component } from 'react';

import { RelatedEntityGrid as EntityGrid } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelCalendar } from 'hay-core-react';
import UsuarioEquipamento from '../../../models/UsuarioEquipamento';
import { Usuario } from 'hay-core-react';
// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    usuario: {
        exibir:       'main.usuario.equipamento.usuario',
        visivel:      true,
        tipo:         'relacao',
        camporelacao: 'nome',
        entidade:     'usuario.entidade',
        template:     'usuario.template',
        validacao:    { obrigatorio: true },
        // Apenas usuários de classificação hotspot podem ter equipamentos cadastrados.
        filtro: {
            classificacao: { constraints: [{ value: 'main.usuario.classificacao.hotspot', matchMode: 'equals' }] },
        },
    },
    mac: {
        exibir:  'main.usuario.equipamento.mac',
        visivel: true,
    },
    validoate: {
        exibir:  'main.usuario.equipamento.validoate',
        visivel: true,
        tipo:    'date',
    },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    usuario: { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class UsuarioEquipamentoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <div className="grid">
                <div className="field col-12 md:col-4 mt-3">
                    <ModelDropDown model={model.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelTextInput model={model.mac} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-4 mt-3">
                    <ModelCalendar model={model.validoate} contexto={contexto} />
                </div>
            </div>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class UsuarioEquipamentoTemplate extends Component {

    processos() {
        return [{
            label:    'main.duplicar',
            icon:     'pi pi-clone',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => { this.gridRef?.duplicar(); },
        }];
    }

    render() {
        return (
            <EntityGrid
                ref={(ref) => this.gridRef = ref}
                entidade={UsuarioEquipamento}
                model={model}
                identidade="main.usuario.equipamento"
                permissoes={this.props.permissoes}
                icone="pi-mobile"
                storageKey="dt-usuarioequipamentos"
                processos={this.processos()}
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                formulario={(m, ctx) => <UsuarioEquipamentoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default UsuarioEquipamentoTemplate;
